// @ts-nocheck
import { useEffect, useState, useRef, useMemo, useCallback } from "react";
import "./ConferenciaCompDespesas.css";
import { Modal, Button, Form } from "react-bootstrap";
import PageLoading from "components/PageLoading";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import NotificationToast from "../../../components/NotificationToast/NotificationToast";
import DadosSindicato from "./ConferenciaCompDespComponents/DadosSindicato/DadosSindicato";
import TabelaReembolso from "./ConferenciaCompDespComponents/TabelaReembolso/TabelaReembolso";
import DadosBancarios from "./ConferenciaCompDespComponents/DadosBancarios/DadosBancarios";
import TabelaValores from "./ConferenciaCompDespComponents/TabelaValores/TabelaValores";
import AcoesFormulario from "./ConferenciaCompDespComponents/AcoesFormulario/AcoesFormulario";
import ExpenseDescription from "./ConferenciaCompDespComponents/DescricaoDespesa/DescricaoDespesa";
import {
  getViewComprovantesDespesasAnaliseByIdSindicato,
  getDespesasExtratosAvaliacaoDetalhe,
  salvarComprovantesDespesasAnalise,
  salvarDespesasExtratoAvaliacaoAnalise,
  solicitarCorrecaoDespesasExtratoAvaliacao,
  solicitarAssinaturaComprovante,
  solicitarAssinaturaDespesasExtratoAvaliacao,
} from "../../../services/FinanceiroService";
import { getSindicatoById } from "../../../services/sindicatoService";
import { mapDespesasExtratoAvaliacaoDetalheToConferenciaPreview } from "../V2/mapDespesasExtratoAvaliacaoDetalheToConferenciaPreview";
import {
  extrairMetadadosSalvarConferencia,
  mergeComprovantesAposSalvarAnaliseLegacy,
} from "../V2/aplicarRespostaSalvarConferencia";
import { extractAxiosErrorMessage } from "../../../services/api";
import { normalizeText } from "../../../utils";
import { PATHS } from "../../../routes/paths";

import PdfComprovantes from "./ConferenciaCompDespComponents/Pdf/PdfComprovantes";
import "./ConferenciaCompDespComponents/Pdf/PdfComprovantes.css";
const LogoFIEMG = `${process.env.PUBLIC_URL || ""}/Fiemg.svg`;

const ConferenciaCompDespesas = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { idSindicato } = useParams();
  const routeState = location.state || {};
  const selectedYear = Number(routeState.selectedYear) || null;
  const extratoId =
    routeState.extratoId ?? routeState.solicitacaoId ?? null;
  const solicitacaoLabel = routeState.solicitacao || "1ª Solicitação";
  const isModoV2 = selectedYear > 2025 && extratoId != null;

  const voltarLista = () => navigate(PATHS.EXTRACT_PAYMENT_TABLE);
  const pageSubtitle =
    isModoV2 && solicitacaoLabel && selectedYear
      ? `${solicitacaoLabel} - ${selectedYear}`
      : null;

  const [liberarParcela, setLiberarParcela] = useState(false);
  const [obsAnalista, setObsAnalista] = useState("");

  const [dadosSindicato, setDadosSindicato] = useState([]);
  const [dadosBancarios, setDadosBancario] = useState([]);
  const [parcelasExtrato, setParcelaExtrato] = useState([]);
  const [comprovantesDespesas, setComprovantesDespesas] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [showConfirmSave, setShowConfirmSave] = useState(false);
  const [despesasReloadKey, setDespesasReloadKey] = useState(0);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const [totais, setTotais] = useState({
    somaParcelasSelecionadas: 0,
    totalDespesas: 0,
    valorSemComprovacao: 0,
    totalQueSeraApoiado: 0,
  });

  const [invalidObsIds, setInvalidObsIds] = useState([]);
  const [triedSolicitar, setTriedSolicitar] = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);

  const [comprovanteSolicitacoes, setComprovanteSolicitacoes] = useState([]);
  const [ComprovanteDespesaCompleto, setComprovantesDespesaCompleto] = useState(
    [],
  );
  const [comprovanteDespesasId, setComprovanteDespesasId] = useState(null);
  const [extratoSolicitacaoId, setExtratoSolicitacaoId] = useState(null);

  const pdfOnlyRef = useRef(null);
  const [logoDataUrl, setLogoDataUrl] = useState(null);
  const [publicando, setPublicando] = useState(false);
  const [solicitandoCorrecao, setSolicitandoCorrecao] = useState(false);
  const [situacaoEnvioComprovante, setSituacaoEnvioComprovante] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const resp = await fetch(LogoFIEMG);
        const blob = await resp.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
          if (alive) setLogoDataUrl(reader.result);
        };
        reader.readAsDataURL(blob);
      } catch (e) {
        console.warn("Falha ao carregar logo:", e);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const waitImagesLoaded = (root) =>
    Promise.all(
      Array.from(root.querySelectorAll("img")).map((img) =>
        img.complete
          ? Promise.resolve()
          : new Promise((res) =>
            img.addEventListener("load", res, { once: true }),
          ),
      ),
    );

  const gerarPdfDaTelaParaFile = async () => {
    // Import dinâmico para evitar crash em testes/SSR quando html2pdf/jspdf não
    // estão totalmente prontos (o handler só roda quando o usuário gerar PDF).
    const html2pdfLib = require("html2pdf.js");
    const html2pdf = html2pdfLib?.default ?? html2pdfLib;

    const el = pdfOnlyRef.current;
    if (!el) throw new Error("Componente do PDF não está montado.");

    await waitImagesLoaded(el);

    const opt = {
      margin: [10, 10, 10, 10],
      filename: `comprovantes_despesas_${new Date().toISOString().slice(0, 10)}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2, useCORS: true, backgroundColor: "#ffffff" },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    let blob;
    try {
      blob = await html2pdf().set(opt).from(el).outputPdf("blob");
    } catch {
      blob = await html2pdf().set(opt).from(el).output("blob");
    }

    return new File([blob], opt.filename, { type: "application/pdf" });
  };

  const isNaoConformeExplicito = (x) =>
    x?.conforme === false ||
    (x?.conforme == null && x?.status === "NAO_CONFORME");

  const isMissingObs = useCallback(
    (x) =>
      isNaoConformeExplicito(x) && String(x?.obsAnalista ?? "").trim() === "",
    [],
  );

  const normalizeStatus = (status) => {
    if (status === "CONFORME" || status === "NAO_CONFORME") return status;
    if (typeof status === "string") {
      const s = status
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .trim()
        .toLowerCase();
      if (["conforme", "aprovado", "ok", "aceito"].includes(s))
        return "CONFORME";
      if (
        [
          "nao_conforme",
          "nao conforme",
          "não conforme",
          "reprovado",
          "nc",
        ].includes(s)
      )
        return "NAO_CONFORME";
    }
    return null;
  };

  const isNaoSolicitado = (d) => {
    let dataSol =
      d?.DataSolicitacao ?? d?.dataSolicitacao ?? d?.data_solicitacao ?? null;

    if (!dataSol && Array.isArray(d.historicoAnaliseAdequacaoDespesa)) {
      const last = [...d.historicoAnaliseAdequacaoDespesa]
        .sort(
          (a, b) =>
            new Date(b?.dataSolicitacao || 0) -
            new Date(a?.dataSolicitacao || 0),
        )
        .shift();
      dataSol = last?.dataSolicitacao ?? null;
    }

    if (typeof dataSol === "string") {
      const s = dataSol.trim();
      if (!s) return true;
      if (/^0001-01-01/.test(s)) return true;
      return false;
    }
    return dataSol == null;
  };

  const tiposNaoConformes = useMemo(() => {
    const byTipo = new Map();

    (comprovantesDespesas || [])
      .filter((d) => d?.conforme === false || isNaoConformeExplicito(d))
      .filter((d) => (d?.conforme === false ? true : isNaoSolicitado(d)))
      .forEach((d) => {
        const id = d?.idTipoDespesa;
        if (id == null) return;
        const nome = d.descricao ?? `Tipo ${id}`;
        const obsA = d.obsAnalista || "";
        const prev = byTipo.get(id);
        if (!prev) byTipo.set(id, { id, nome, obsAnalista: obsA });
        else if (!prev.obsAnalista && obsA)
          byTipo.set(id, { ...prev, obsAnalista: obsA });
      });

    return Array.from(byTipo.values());
  }, [comprovantesDespesas]);

  /** V2: status da API não usa "solicitando"; libera assinatura fora de estados bloqueados. */
  const situacaoNorm = useMemo(
    () => normalizeText(situacaoEnvioComprovante),
    [situacaoEnvioComprovante],
  );

  const isAssinaturaExpirada =
    isModoV2 && situacaoNorm.includes("assinatura expirada");
  const isAssinaturaPendente =
    isModoV2 && situacaoNorm.includes("assinatura pendente");
  const isAssinaturaConcluida =
    isModoV2 && situacaoNorm.includes("assinatura concluida");
  const isCorrecaoPendente =
    isModoV2 && situacaoNorm.includes("correcao pendente");

  const bloquearEdicaoGeral =
    isAssinaturaExpirada ||
    isAssinaturaPendente ||
    isAssinaturaConcluida ||
    isCorrecaoPendente;

  const showSolicitarAssinatura = useMemo(() => {
    if (!isModoV2) return undefined;
    if (!situacaoNorm) return true;
    if (situacaoNorm.includes("comprovantes pendente")) return false;
    if (situacaoNorm.includes("correcao pendente")) return false;
    if (situacaoNorm.includes("assinatura pendente")) return false;
    if (situacaoNorm.includes("assinatura concluida")) return false;
    if (situacaoNorm.includes("inapto")) return false;
    return true;
  }, [isModoV2, situacaoNorm]);

  const getLastHist = (x = {}) => {
    const hist = Array.isArray(x.historicoAnaliseAdequacaoDespesa)
      ? x.historicoAnaliseAdequacaoDespesa
      : [];
    if (!hist.length) return null;

    const histFiltrado = hist.filter(
      (h) =>
        Number(h?.idComprovanteDespesa) === Number(x?.idComprovanteDespesa),
    );
    if (!histFiltrado.length) return null;

    return histFiltrado.reduce((ultimo, atual) =>
      (atual?.id ?? 0) > (ultimo?.id ?? 0) ? atual : ultimo,
    );
  };

  const asBool = (v) =>
    v === true || v === 1 || v === "1" || String(v).toLowerCase() === "true";

  const getAnaliseIdEfetivo = (x) => {
    const idDireto = Number(x.idAnalise) || 0;
    if (idDireto > 0) return idDireto;

    const hist = Array.isArray(x.historicoAnaliseAdequacaoDespesa)
      ? x.historicoAnaliseAdequacaoDespesa
      : [];
    if (!hist.length) return 0;

    const last = [...hist]
      .sort((a, b) => {
        const ad = new Date(
          a?.dataCorrecao || a?.dataSolicitacao || 0,
        ).getTime();
        const bd = new Date(
          b?.dataCorrecao || b?.dataSolicitacao || 0,
        ).getTime();
        if (ad !== bd) return ad - bd;
        return (a?.id ?? 0) - (b?.id ?? 0);
      })
      .pop();

    return Number(last?.id) || 0;
  };

  const getIdForSolicitacao = (x) => {
    const last = getLastHist(x);
    const conforme = asBool(x?.conforme ?? last?.conforme);
    const dataCorrecao = x?.dataCorrecao ?? last?.dataCorrecao ?? null;
    const correcaoRealizada = asBool(
      x?.correcaoRealizada ?? last?.correcaoRealizada,
    );
    if (correcaoRealizada || dataCorrecao) return 0;
    if (!conforme) return last?.id || 0;
    if (conforme && !correcaoRealizada) return last?.id || 0;
    return 0;
  };

  const aplicarPreviewNoEstado = useCallback((preview, { bumpReloadKey = false } = {}) => {

    hidratandoLiberarParcelaRef.current = true;
    setSituacaoEnvioComprovante(preview.situacaoEnvioComprovante ?? "");
    setLiberarParcela(!!preview.liberarTotalParcelas);
    setObsAnalista(preview.obsAnalista ?? "");
    setDadosBancario(preview.dadosBancarios || {});
    setComprovanteSolicitacoes(preview.comprovanteSolicitacoes || []);
    setParcelaExtrato(preview.parcelasExtrato || []);
    setComprovantesDespesaCompleto(preview.comprovantesDespesas || []);
    setComprovantesDespesas(preview.comprovantesDespesas || []);
    setComprovanteDespesasId(preview.comprovanteDespesasId ?? null);
    setExtratoSolicitacaoId(preview.extratoSolicitacaoId ?? null);
    if (bumpReloadKey) setDespesasReloadKey((k) => k + 1);
  }, []);

  const carregarDadosConferencia = useCallback(async (options = {}) => {
    const { silent = false } = options;
    if (!idSindicato && !isModoV2) return;
    if (!silent) setCarregando(true);
    try {
      if (isModoV2) {
        const detalhe = await getDespesasExtratosAvaliacaoDetalhe(extratoId);
        if (!detalhe) {
          throw new Error("Detalhe do comprovante não encontrado.");
        }

        const preview = mapDespesasExtratoAvaliacaoDetalheToConferenciaPreview(
          detalhe,
          solicitacaoLabel,
        );

        if (idSindicato) {
          const dadosSindicatosCompleto = await getSindicatoById(idSindicato);
          setDadosSindicato(
            dadosSindicatosCompleto?.data || {
              cnpj: detalhe?.dadosSindicato?.cnpj,
              nome: detalhe?.dadosSindicato?.nome,
            },
          );
        } else {
          setDadosSindicato({
            cnpj: detalhe?.dadosSindicato?.cnpj,
            nome: detalhe?.dadosSindicato?.nome,
          });
        }

        // silent=true é usado para recarregar depois de uma ação do usuário já
        // concluída (solicitar correção, publicar, assinatura enviada) — nesses
        // casos precisamos forçar o DescricaoDespesa a resincronizar com o dado
        // canônico (ex.: "aguardando retorno do sindicato" após solicitar
        // correção). No carregamento inicial (silent=false) não é necessário:
        // o componente ainda não foi inicializado e sincroniza sozinho.
        aplicarPreviewNoEstado(preview, { bumpReloadKey: silent });
        return;
      }

      const sindicato =
        await getViewComprovantesDespesasAnaliseByIdSindicato(idSindicato);

      setSituacaoEnvioComprovante(sindicato?.situacaoEnvioComprovante ?? "");
      setLiberarParcela(!!sindicato?.liberarTotalParcelas);
      setObsAnalista(sindicato?.obsAnalista ?? "");

      const dadosSindicatosCompleto = await getSindicatoById(idSindicato);
      setDadosSindicato(dadosSindicatosCompleto?.data || []);
      setDadosBancario(sindicato?.dadosBancarios || []);

      const solicitacoes = sindicato?.comprovanteSolicitacoes || [];
      setExtratoSolicitacaoId(null);
      setComprovanteSolicitacoes(solicitacoes);

      const mapSolic = solicitacoes.reduce((acc, s) => {
        acc[s.idTipoParcela] = s.idSolicitacao;
        return acc;
      }, {});

      const parcelasComSolic = (sindicato?.parcelasExtrato || []).map(
        (p) => ({
          ...p,
          idSolicitacao: mapSolic[p.idTipoParcela] || null,
        }),
      );
      setParcelaExtrato(parcelasComSolic);

      const comprovantes = sindicato?.comprovantesDespesas || [];
      setComprovantesDespesaCompleto(comprovantes);

      const analises =
        sindicato?.analisesDespesas || sindicato?.analises || [];
      const byComp = new Map(
        analises.map((a) => [Number(a.idComprovanteDespesa), a]),
      );

      const compsMerge = comprovantes.map((c) => {
        const idComp = Number(c.id);
        const a = byComp.get(idComp);
        const statusNorm = normalizeStatus(c?.status);

        const lastHist = getLastHist(c);
        const conformeFromHist =
          typeof lastHist?.conforme === "boolean" ? lastHist.conforme : null;
        const obsFromHist = (lastHist?.obsAnalista || "").trim();

        let conformeTri = null;
        if (typeof a?.conforme === "boolean") conformeTri = a.conforme;
        else if (conformeFromHist != null) conformeTri = conformeFromHist;
        else if (statusNorm) conformeTri = statusNorm === "CONFORME";
        else conformeTri = null;

        const statusFinal =
          typeof conformeTri === "boolean"
            ? conformeTri
              ? "CONFORME"
              : "NAO_CONFORME"
            : (statusNorm ?? null);

        return {
          ...c,
          idComprovanteDespesa: idComp,
          idAnalise: Number(a?.id) || 0,
          status: statusFinal,
          conforme: conformeTri,
          obsAnalista:
            obsFromHist ||
            a?.obsAnalista?.trim() ||
            c?.obsAnalista?.trim() ||
            "",
          primeiraParcela: !!c.primeiraParcela,
          segundaParcela: !!c.segundaParcela,
        };
      });

      setComprovantesDespesas(compsMerge);
    } catch (e) {
      console.error("Erro ao carregar dados da conferência:", e);
    } finally {
      if (!silent) setCarregando(false);
    }
  }, [extratoId, idSindicato, isModoV2, solicitacaoLabel, aplicarPreviewNoEstado]);

  useEffect(() => {
    carregarDadosConferencia();
  }, [carregarDadosConferencia]);

  const handleToggleLiberarParcela = (checked) => {
    setLiberarParcela(checked);
    if (!checked) setObsAnalista("");
  };

  const totaisRecebidosRef = useRef(false);
  const hidratandoLiberarParcelaRef = useRef(false);

  const handleTotalsChange = useCallback((next) => {
    totaisRecebidosRef.current = true;
    setTotais(next);
  }, []);

  // Só limpa após os totais reais chegarem da TabelaValores —
  // evita apagar liberar/obs vindos do GET enquanto valorSemComprovacao ainda é 0.
  useEffect(() => {

    if (hidratandoLiberarParcelaRef.current) {
      hidratandoLiberarParcelaRef.current = false;
      return;
    }
    if (!totaisRecebidosRef.current) return;
    if (totais.valorSemComprovacao <= 0 && liberarParcela) {
      setLiberarParcela(false);
      setObsAnalista("");
    }
  }, [totais.valorSemComprovacao, liberarParcela]);

  const validarLiberarValorTotal = () => {
    if (liberarParcela && !String(obsAnalista ?? "").trim()) {
      setToast({
        show: true,
        type: "error",
        message:
          "Informe a justificativa para liberar o valor total da solicitação.",
      });
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (!triedSolicitar) return;
    const faltando = (comprovantesDespesas || []).filter(isMissingObs);
    setInvalidObsIds(faltando.map((x) => x.identificador));
  }, [comprovantesDespesas, triedSolicitar, isMissingObs]);

  const hasVal = (v) => v != null && String(v).trim() !== "";

  const observacaoParaEnviar = (x) => String(x?.obsAnalista ?? "").trim();

  const aplicarEstadoAposSalvar = (resp, { analisesEnviadas = [], payloadV2 = null } = {}) => {
    if (payloadV2) {
      const preview = mapDespesasExtratoAvaliacaoDetalheToConferenciaPreview(
        resp || {},
        solicitacaoLabel,
      );
      aplicarPreviewNoEstado(preview, { bumpReloadKey: true });
      return;
    }

    setComprovantesDespesas((curr) =>
      mergeComprovantesAposSalvarAnaliseLegacy(curr, resp, analisesEnviadas),
    );

    const meta = extrairMetadadosSalvarConferencia(resp);
    if (meta.liberarTotalParcelas != null) {
      setLiberarParcela(!!meta.liberarTotalParcelas);
    }
    if (meta.obsAnalista !== undefined) {
      setObsAnalista(meta.obsAnalista);
    }
    setDespesasReloadKey((k) => k + 1);
  };

  const getPreservedSolic = (x) => {
    const direct = x.dataSolicOriginal || x.solicitadoCorrecaoEm || null;
    if (direct) return direct;

    const hist = Array.isArray(x.historicoAnaliseAdequacaoDespesa)
      ? x.historicoAnaliseAdequacaoDespesa
      : [];

    const ordered = [...hist].sort((a, b) => {
      const ad = new Date(
        a?.dataCorrecao || a?.dataSolicitacao || 0,
      ).getTime();
      const bd = new Date(
        b?.dataCorrecao || b?.dataSolicitacao || 0,
      ).getTime();
      return ad - bd;
    });

    for (let i = ordered.length - 1; i >= 0; i--) {
      const ds = ordered[i]?.dataSolicitacao;
      if (ds && !Number.isNaN(new Date(ds).getTime())) return ds;
    }
    return null;
  };

  const terQueCriarUmNovo = (x) => {
    const last = getLastHist(x);
    if (!last) return false;

    const temSolic = hasVal(last?.dataSolicitacao);
    const temCorr = hasVal(last?.dataCorrecao);
    const corrReal = asBool(last?.correcaoRealizada);
    const eraNC =
      last?.conforme === false || String(last?.conforme) === "false";
    return temSolic && temCorr && corrReal && eraNC;
  };

  const montarAnalisesDespesasLegacy = () =>
    (comprovantesDespesas || [])
      .filter(
        (x) =>
          typeof x.conforme === "boolean" || hasVal(x?.obsAnalista),
      )
      .map((x) => {
        const idExistente = Number(x?.idAnalise) || 0;
        const criarNovo = terQueCriarUmNovo(x);

        const base = {
          id: criarNovo ? 0 : idExistente,
          idComprovanteDespesa:
            Number(x?.idComprovanteDespesa) || Number(x?.id) || 0,
          conforme: typeof x?.conforme === "boolean" ? x.conforme : null,
          obsAnalista: observacaoParaEnviar(x),
        };

        if (!criarNovo && idExistente > 0) {
          const preservedSolic = getPreservedSolic(x);
          const preservedCorrecao = x?.corrigidoEm || null;
          if (hasVal(preservedSolic)) base.dataSolicitacao = preservedSolic;
          if (hasVal(preservedCorrecao))
            base.dataCorrecao = preservedCorrecao;
        }

        return base;
      });

  const montarPayloadSalvarLegacy = (solicitarCorrecao = false) => ({
    idSindicato: Number(idSindicato),
    solicitarCorrecao,
    liberarTotalParcelas: liberarParcela,
    obsAnalista,
    analisesDespesas: montarAnalisesDespesasLegacy(),
  });

  const montarPayloadAnaliseV2 = () => {
    const despesas = (comprovantesDespesas || [])
      .filter(
        (x) =>
          typeof x.conforme === "boolean" ||
          String(x?.obsAnalista ?? "").trim() !== "",
      )
      .map((x) => {
        const criarNovo = terQueCriarUmNovo(x);
        const idExistente = Number(x?.idAnalise) || 0;

        // 1º save (ou novo ciclo após correção) → null; senão id da análise do GET PAI.
        const analiseId =
          criarNovo || idExistente <= 0 ? null : idExistente;

        return {
          despesaExtratoAvaliacaoId:
            Number(x?.idComprovanteDespesa) || Number(x?.id) || 0,
          analiseDespesaExtratoAvaliacaoId: analiseId,
          emConformidade:
            typeof x?.conforme === "boolean" ? x.conforme : null,
          observacaoAnalista: observacaoParaEnviar(x),
        };
      });

    return {
      liberarValorTotalSolicitacao: !!liberarParcela,
      observacaoAnalista: liberarParcela
        ? String(obsAnalista ?? "").trim()
        : null,
      despesas,
    };
  };

  const salvarAnaliseV2 = async () => {
    if (comprovanteDespesasId == null) {
      throw new Error(
        "comprovanteDespesasId não encontrado para salvar análise (V2).",
      );
    }
    const payload = montarPayloadAnaliseV2();
    const resp = await salvarDespesasExtratoAvaliacaoAnalise(
      comprovanteDespesasId,
      payload,
    );
    return { resp, payload };
  };

  const handleSave = async () => {
    if (!validarLiberarValorTotal()) return;

    try {
      setCarregando(true);

      if (isModoV2) {
        const { resp, payload } = await salvarAnaliseV2();
        aplicarEstadoAposSalvar(resp, { payloadV2: payload });
      } else {
        const payload = montarPayloadSalvarLegacy(false);
        const resp = await salvarComprovantesDespesasAnalise(payload);
        aplicarEstadoAposSalvar(resp, {
          analisesEnviadas: payload.analisesDespesas,
        });
      }

      setToast({
        show: true,
        message: "Comprovante de Despesa salvo com sucesso!",
        type: "success",
      });
    } catch (e) {
      console.error(e);
      setToast({
        show: true,
        type: "error",
        message:
          extractAxiosErrorMessage(e) || "Falha ao salvar. Tente novamente.",
      });
    } finally {
      setCarregando(false);
    }
  };

  const isMarcadoConformeOuNao = (x) => typeof x?.conforme === "boolean";

  const scrollToComprovante = (comp) => {
    const selByIdAttr = document.querySelector(
      `[data-comp-id="${comp?.idComprovanteDespesa || comp?.id}"]`,
    );
    const selByIdent = comp?.identificador
      ? document.querySelector(`[data-identificador="${comp.identificador}"]`)
      : null;

    const el = selByIdAttr || selByIdent;
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const validarAntesDePublicar = () => {
    const lista = Array.isArray(comprovantesDespesas)
      ? comprovantesDespesas
      : [];
    const faltandoMarcacao = lista.filter((x) => !isMarcadoConformeOuNao(x));

    if (faltandoMarcacao.length > 0) {
      scrollToComprovante(faltandoMarcacao[0]);
      setToast({
        show: true,
        type: "error",
        message:
          'Marque "Conforme" ou "Não conforme" em todos os itens antes de publicar.',
      });
      return false;
    }
    return true;
  };

  const salvarSemReload = async () => {
    try {
      if (isModoV2) {
        const { resp, payload } = await salvarAnaliseV2();
        aplicarEstadoAposSalvar(resp, { payloadV2: payload });
        return true;
      }

      const payload = montarPayloadSalvarLegacy(false);
      const resp = await salvarComprovantesDespesasAnalise(payload);
      aplicarEstadoAposSalvar(resp, {
        analisesEnviadas: payload.analisesDespesas,
      });

      return true;
    } catch (e) {
      console.error("[Publicar] Falha ao salvar (pré-publicação):", e);
      setToast({
        show: true,
        type: "error",
        message:
          extractAxiosErrorMessage(e) ||
          "Não foi possível salvar os dados antes de publicar.",
      });
      return false;
    }
  };

  const validarESalvarAntesDePublicar = async () => {
    const ok = validarAntesDePublicar();
    if (!ok) return false;
    if (!validarLiberarValorTotal()) return false;
    return await salvarSemReload();
  };

  const validarESalvarAntesDeSolicitarCorrecao = async () => {
    setTriedSolicitar(true);

    const faltando = (comprovantesDespesas || []).filter(isMissingObs);
    if (faltando.length > 0) {
      setInvalidObsIds(faltando.map((x) => x.identificador));
      setToast({
        show: true,
        type: "error",
        message: "Informe a observação para todos os itens NÃO CONFORMES.",
      });
      setShowValidationModal(true);
      return false;
    }

    if (!validarLiberarValorTotal()) return false;

    return await salvarSemReload();
  };

  const atualizarHistoricoAposSolicitarCorrecao = (analisesDespesas, agora) => {
    const byCompSolic = new Map(
      analisesDespesas.map((a) => [
        Number(a.idComprovanteDespesa),
        a.dataSolicitacao ?? agora,
      ]),
    );

    setComprovantesDespesas((curr) =>
      (curr || []).map((c) => {
        const ds = byCompSolic.get(Number(c.idComprovanteDespesa));
        if (!ds) return c;

        const historico = Array.isArray(c.historicoAnaliseAdequacaoDespesa)
          ? [...c.historicoAnaliseAdequacaoDespesa]
          : [];

        if (historico.length) {
          const lastIdx = historico.length - 1;
          const last = historico[lastIdx] || {};
          historico[lastIdx] = {
            ...last,
            dataSolicitacao: last?.dataSolicitacao || ds,
            conforme: false,
            correcaoRealizada: false,
            dataCorrecao: last?.dataCorrecao ?? null,
          };
        } else {
          historico.push({
            id: getAnaliseIdEfetivo(c) || 0,
            idComprovanteDespesa: Number(c.idComprovanteDespesa) || 0,
            obsAnalista: String(c.obsAnalista ?? ""),
            obsSindicato: "",
            conforme: false,
            dataSolicitacao: ds,
            dataCorrecao: null,
            correcaoRealizada: false,
          });
        }

        return { ...c, historicoAnaliseAdequacaoDespesa: historico };
      }),
    );
    setDespesasReloadKey((k) => k + 1);
  };

  const handlePublicarFormulario = async ({ email, observacao }) => {
    if (publicando) return;

    setPublicando(true);
    try {

      const file = await gerarPdfDaTelaParaFile();

      if (isModoV2) {
        if (comprovanteDespesasId == null) {
          throw new Error(
            "comprovanteDespesasId não encontrado para solicitar assinatura (V2).",
          );
        }

        await solicitarAssinaturaDespesasExtratoAvaliacao(comprovanteDespesasId, {
          arquivo: file,
          emailAprovador: email,
        });
      } else {
        const ok = await solicitarAssinaturaComprovante({
          idSindicato: Number(idSindicato),
          Arquivo: [file],
          EmailSignatario: email,
          Observacao: observacao,
        });
        if (!ok) {
          throw new Error("Falha ao solicitar assinatura (legado).");
        }
      }

      setToast({
        show: true,
        type: "success",
        message: "Solicitação de assinatura enviada com sucesso!",
      });
      await carregarDadosConferencia({ silent: true });
    } catch (e) {
      console.error("[Publicar] Erro no fluxo de publicação:", e);
      setToast({
        show: true,
        type: "error",
        message:
          extractAxiosErrorMessage(e) ||
          "Não foi possível concluir. Tente novamente.",
      });
    } finally {
      setPublicando(false);
    }
  };

  const nowISO = () => new Date().toISOString();

  const handleSolicitarCorrecao = async () => {
    try {
      setSolicitandoCorrecao(true);

      if (isModoV2) {
        await solicitarCorrecaoDespesasExtratoAvaliacao(comprovanteDespesasId);
        setToast({
          show: true,
          type: "success",
          message: "Solicitação de correção enviada com sucesso!",
        });
        await carregarDadosConferencia({ silent: true });
        return;
      }

      const agora = nowISO();

      const analisesDespesas = (comprovantesDespesas || []).map((x) => {
        const obs = observacaoParaEnviar(x);
        const conforme = typeof x?.conforme === "boolean" ? x.conforme : false;

        return {
          id: getIdForSolicitacao(x),
          idComprovanteDespesa: Number(x.idComprovanteDespesa) || 0,
          conforme,
          obsAnalista: obs,
          dataSolicitacao: agora,
        };
      });

      const payload = {
        idSindicato: Number(idSindicato),
        solicitarCorrecao: true,
        liberarTotalParcelas: !!liberarParcela,
        obsAnalista,
        analisesDespesas,
      };

      const resp = await salvarComprovantesDespesasAnalise(payload);
      aplicarEstadoAposSalvar(resp, { analisesEnviadas: analisesDespesas });
      atualizarHistoricoAposSolicitarCorrecao(analisesDespesas, agora);

      setToast({
        show: true,
        type: "success",
        message: "Solicitação de correção enviada com sucesso!",
      });
    } catch (e) {
      console.error(e);
      setToast({
        show: true,
        type: "error",
        message:
          extractAxiosErrorMessage(e) || "Falha ao enviar solicitação.",
      });
    } finally {
      setSolicitandoCorrecao(false);
    }
  };

  const despesasParaPdf = useMemo(
    () =>
      (comprovantesDespesas || []).map((d, i) => ({
        descricao: d?.descricao || d?.titulo || d?.tipo || `Despesa ${i + 1}`,
        valor: Number(d?.valor ?? d?.valorComprovado ?? 0),
      })),
    [comprovantesDespesas],
  );

  const resumoParaPdf = useMemo(
    () => ({
      totalComprovado: totais?.totalDespesas ?? 0,
      totalQueSeraApoiado:
        totais?.totalQueSeraApoiado ?? totais?.totalDespesas ?? 0,
    }),
    [totais],
  );

  const dadosSindicatoPdf = useMemo(
    () => ({
      razaoSocial:
        dadosSindicato?.razaoSocial ||
        dadosSindicato?.nome ||
        dadosSindicato?.nomeSindicato ||
        "—",
      cnpj: dadosSindicato?.cnpj || dadosSindicato?.cnpjSindicato || "",
      presidenteNome: dadosSindicato?.nomePresidente || "",
    }),
    [dadosSindicato],
  );

  const dadosBancariosPdf = useMemo(
    () => ({
      tipoConta: dadosBancarios?.tipoContaDescricao || "",
      banco: dadosBancarios?.banco || dadosBancarios?.codigoBanco || "",
      agencia: dadosBancarios?.agencia || "",
      conta: dadosBancarios?.conta || "",
    }),
    [dadosBancarios],
  );

  const year = selectedYear || new Date().getFullYear();
  const textosPdf = useMemo(
    () => ({
      header: "Apoio para Sindicatos Empresariais filiados à FIEMG",
      intro: `Apoio ao Sindicato referente ao Programa de Meritocracia Sindial ${year}.`,
      solicitacaoRef: pageSubtitle || undefined,
    }),
    [year, pageSubtitle],
  );

  if (carregando) return <PageLoading />;

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-primary fw-bold m-0">COMPROVANTES DE DESPESAS</h2>
        <div className="d-flex flex-column align-items-end gap-1">
          <FaArrowLeft
            className="merit-voltar-seta seta-voltar"
            onClick={voltarLista}
            role="button"
            size={20}
            title="Voltar para a lista de comprovantes"
            aria-label="Voltar para a lista de comprovantes"
          />
          {pageSubtitle && (
            <span className="text-muted small">{pageSubtitle}</span>
          )}
        </div>
      </div>

      <DadosSindicato DadosSindicato={dadosSindicato} />

      <TabelaReembolso
        TabelaReembolso={parcelasExtrato}
        idSindicato={idSindicato}
        extratoSolicitacaoId={extratoSolicitacaoId}
        solicitacoes={comprovanteSolicitacoes}
        situacaoEnvioComprovante={situacaoEnvioComprovante}
        modoSimples={isModoV2}
        onAssinaturaEnviadaSuccess={() =>
          carregarDadosConferencia({ silent: true })
        }
      />

      <DadosBancarios dadosBancarios={dadosBancarios} />

      <ExpenseDescription
        DadosDespesas={comprovantesDespesas}
        onChange={setComprovantesDespesas}
        reloadKey={despesasReloadKey}
        invalidObsIds={new Set(invalidObsIds)}
        parcelas={parcelasExtrato}
        comprovantes={ComprovanteDespesaCompleto}
        bloquearEdicao={bloquearEdicaoGeral}
      />

      <TabelaValores
        TabelaReembolso={parcelasExtrato}
        DadosDespesas={comprovantesDespesas}
        liberarParcela={liberarParcela}
        usarTodasParcelas={isModoV2}
        onTotalsChange={handleTotalsChange}
      />

      {totais.valorSemComprovacao > 0 && (
        <Form.Group className="mt-3 text-start">
          <Form.Check
            type="checkbox"
            label="Liberar valor total da solicitação"
            checked={liberarParcela}
            onChange={(e) => handleToggleLiberarParcela(e.target.checked)}
            disabled={bloquearEdicaoGeral}
          />

          {liberarParcela && (
            <>
              <Form.Label className="mt-3">Observação do analista:</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                maxLength={1000}
                placeholder="Adicionar texto"
                value={obsAnalista}
                onChange={(e) => setObsAnalista(e.target.value)}
                disabled={bloquearEdicaoGeral}
              />
              <div className="text-muted text-end">
                Limite máximo: 1.000 caracteres
              </div>
            </>
          )}
        </Form.Group>
      )}

      <AcoesFormulario
        onSalvar={() => {
          if (!validarLiberarValorTotal()) return;
          setShowConfirmSave(true);
        }}
        onPrePublicar={validarESalvarAntesDePublicar}
        onPublicarFormulario={handlePublicarFormulario}
        onPreSolicitarCorrecao={validarESalvarAntesDeSolicitarCorrecao}
        onSolicitarCorrecao={handleSolicitarCorrecao}
        showSalvar={!bloquearEdicaoGeral}
        showSolicitarCorrecao={
          !bloquearEdicaoGeral && tiposNaoConformes.length > 0
        }
        showSolicitarAssinatura={showSolicitarAssinatura}
        skipPreSalvarAssinatura={isAssinaturaExpirada}
        isPublishing={publicando}
        isSolicitandoCorrecao={solicitandoCorrecao}
        TabelaReembolso={parcelasExtrato}
      />

      {toast.show && (
        <NotificationToast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, show: false })}
        />
      )}

      <Modal
        show={showConfirmSave}
        onHide={() => setShowConfirmSave(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmar salvamento</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          Ao clicar em <strong>Salvar</strong>, as informações serão salvas no
          sistema para depois dar continuidade na conferência.
          <p className="mt-3 mb-0">Deseja realmente salvar?</p>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <Button
            variant="danger"
            onClick={() => setShowConfirmSave(false)}
            disabled={carregando}
          >
            Não
          </Button>

          <Button
            className="btn-confirmar"
            onClick={async () => {
              setShowConfirmSave(false);
              await handleSave();
            }}
            disabled={carregando}
          >
            Sim
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showValidationModal}
        onHide={() => setShowValidationModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Campos obrigatórios</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          Para enviar a solicitação de correção você deve preencher todos os
          campos obrigatórios.
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="primary"
            onClick={() => setShowValidationModal(false)}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      <div
        style={{
          position: "absolute",
          left: "-10000px",
          top: 0,
          width: "750px",
        }}
      >
        <PdfComprovantes
          ref={pdfOnlyRef}
          logoSrc={logoDataUrl || LogoFIEMG}
          dadosSindicato={dadosSindicatoPdf}
          dadosBancarios={dadosBancariosPdf}
          descricaoDespesas={despesasParaPdf}
          resumoValores={resumoParaPdf}
          textos={textosPdf}
        />
      </div>
    </div>
  );
};

export default ConferenciaCompDespesas;
